export interface FeedbackTicket {
  id: number
  title: string
  description: string
  type: 'bug' | 'feature'
  status: KanbanStatus
  priority: TicketPriority
  submitted_by: string
  submitted_by_name: string | null
  ai_summary: string | null
  related_tickets_json: string
  append_history_json: string
  created_at: string
  updated_at: string
}

export type KanbanStatus = 'backlog' | 'in_progress' | 'done'
export type TicketPriority = 'low' | 'medium' | 'high' | 'critical'
export type TicketType = 'bug' | 'feature'

export interface SubmitFeedbackInput {
  description: string
  type: TicketType
  user_email: string
  user_name: string
}

export interface SubmitFeedbackResult {
  action: 'new' | 'append'
  ticket: FeedbackTicket
}

export interface RefineInput {
  description: string
  type: TicketType
  answers?: { question: string; answer: string }[]
}

export interface RefineResult {
  questions?: string[]
  structured?: string
  ready?: boolean
}

export interface AppendHistoryEntry {
  user_email: string
  user_name: string
  description: string
  date: string
}

export const KANBAN_COLUMNS: { id: KanbanStatus; label: string }[] = [
  { id: 'backlog', label: 'Backlog' },
  { id: 'in_progress', label: 'In Progress' },
  { id: 'done', label: 'Done' },
]

export const PRIORITY_ORDER: Record<TicketPriority, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
}
